import { Testimonial } from '../types';
import { testimonials as defaultTestimonials } from '../data/mockData';

const TESTIMONIALS_STORAGE_KEY = 'chc_testimonials_v1';

export function getTestimonials(): Testimonial[] {
  try {
    const raw = localStorage.getItem(TESTIMONIALS_STORAGE_KEY);
    if (!raw) return defaultTestimonials;
    return JSON.parse(raw);
  } catch (e) {
    console.error('Failed to parse testimonials from storage:', e);
    return defaultTestimonials;
  }
}

export function saveTestimonials(testimonials: Testimonial[]): Testimonial[] {
  try {
    localStorage.setItem(TESTIMONIALS_STORAGE_KEY, JSON.stringify(testimonials));
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('chc_testimonials_updated', { detail: testimonials }));
    }
  } catch (e) {
    console.error('Failed to save testimonials:', e);
  }
  return testimonials;
}
